import { TableBody, TableCell, TableRow, CircularProgress, TableHead } from '@mui/material';
import { DataTableHeaders, DataTableLoadingWrapper, DataTableWrapper, NoResultWrapper, StyledTable } from '@styles/ContactManager/ContactStyles';

import { IDataTableCell, IDataTableHeader, IDataTableProps, TDataTableRow } from '../../interfaces';

export const DataTable = ({ rows, title, margin, headers, loading, noResultText }: IDataTableProps) => (
  <DataTableWrapper margin={margin}>
    <StyledTable>
      {title && <TableHead sx={{ fontWeight: '700' }} >{title}</TableHead>}

      {headers && (
        <DataTableHeaders>
          {headers.map((header: IDataTableHeader, headerIndex: number) => (
            <TableCell
              key={headerIndex}
              component="th"
              scope="row"
              align={header.align ?? 'left'}
              style={{ width: 'auto' }}
            >
              {header.label}
            </TableCell>
          ))}
        </DataTableHeaders>
      )}

      {!loading && !!rows.length && (
        <TableBody>
          {rows.map((row: TDataTableRow, rowIndex: number) => (
            <TableRow key={rowIndex}>
              {row.map((cell: IDataTableCell, cellIndex: number) => (
                <TableCell key={cellIndex} align={cell.align ?? 'left'}>
                  {cell.value}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      )}
    </StyledTable>

    {!rows.length && noResultText && !loading ? (
      <NoResultWrapper>{noResultText}</NoResultWrapper>
    ) : (
      <>
        {loading && (
          <DataTableLoadingWrapper>
            <CircularProgress />
          </DataTableLoadingWrapper>
        )}
      </>
    )}
  </DataTableWrapper>
);
